// src/store/adminDashboardSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedOrganisation: "", // Store selected organisation ID
};

const adminDashboardSlice = createSlice({
  name: "adminDashboard",
  initialState,
  reducers: {
    setSelectedOrganisation: (state, action) => {
      state.selectedOrganisation = action.payload;
    },
    clearSelectedOrganisation: (state) => {
      state.selectedOrganisation = "";
    },
  },
});

export const { setSelectedOrganisation, clearSelectedOrganisation } =
  adminDashboardSlice.actions;

export default adminDashboardSlice.reducer;
